/******/ (() => { // webpackBootstrap
/*!******************************!*\
  !*** ./src/js/collection.js ***!
  \******************************/
function sortBy() {
  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');
    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');
      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelectorAll('#sort-by').forEach(function (sortBy) {
    sortBy.addEventListener('change', function (e) {
      var value = e.target.value;
      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });
  });
}
function removeProductCards() {
  var mobileProductCards = document.querySelector('.js-mobile-cards'),
    desktopProductCards = document.querySelector('.js-desktop-cards'),
    windowWidth = window.innerWidth,
    activeViewport = window.innerWidth < 1024 ? 'mobile' : 'desktop';
  if (windowWidth < 1024) {
    desktopProductCards === null || desktopProductCards === void 0 ? void 0 : desktopProductCards.remove();
  } else {
    mobileProductCards === null || mobileProductCards === void 0 ? void 0 : mobileProductCards.remove();
  }
  window.addEventListener('resize', function (e) {
    var newActiveViewport = window.innerWidth < 1024 ? 'mobile' : 'desktop',
      newMobileProductCards = document.querySelector('.js-mobile-cards'),
      newDesktopProductCards = document.querySelector('.js-desktop-cards'),
      productCardsWrapper = document.querySelector('.js-collection-cards');
    if (activeViewport != newActiveViewport) {
      activeViewport = newActiveViewport;
      if (activeViewport == 'desktop') {
        productCardsWrapper === null || productCardsWrapper === void 0 ? void 0 : productCardsWrapper.appendChild(desktopProductCards);
        newMobileProductCards === null || newMobileProductCards === void 0 ? void 0 : newMobileProductCards.remove();
      } else {
        productCardsWrapper === null || productCardsWrapper === void 0 ? void 0 : productCardsWrapper.appendChild(mobileProductCards);
        newDesktopProductCards === null || newDesktopProductCards === void 0 ? void 0 : newDesktopProductCards.remove();
      }
    }
  });
}
var initCollectionLocks = function initCollectionLocks() {
  document.addEventListener("DOMContentLoaded", function () {
    var _window$Shopify, _window$Shopify2;
    var modal = document.querySelector('[data-modal-overlay-bg]');
    var modalBox = document.querySelector('[data-lock-modal-box]');
    var modalCloseButton = document.querySelector('[data-close-lock-modal]');
    var modalContent = document.querySelector('[data-lock-content]');
    var successButtonsWrapper = document.querySelector('[data-success-buttons]');
    console.log('modal', modal);
    if (!modal || !modalContent || !modalBox) return;

    // Retrieve data attributes
    var successDescription = modalContent.getAttribute('data-success-description');
    var successTitle = modalContent.getAttribute('data-success-title');
    var defaultDescription = modalContent.getAttribute('data-default-description');
    var defaultTitle = modalContent.getAttribute('data-default-title');
    var pageLockType = modalContent.getAttribute('data-page-lock-type');
    var collectionHandle = modalContent.getAttribute('data-collection-handle'); // Add this attribute in Liquid

    var localStorageKey = "is_collection_unlocked_".concat(collectionHandle); // Unique key for each collection

    var urlParams = new URLSearchParams(window.location.search);
    var isAccessLink = urlParams.get('view') === 'access';
    var isUnlocked = localStorage.getItem(localStorageKey) === "true";
    var isCustomerLoggedIn = window.Shopify && ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.customer);
    var acceptsMarketing = (_window$Shopify2 = window.Shopify) === null || _window$Shopify2 === void 0 ? void 0 : _window$Shopify2.accepts_marketing;

    // If the collection is already unlocked, hide the modal
    if (isUnlocked) {
      modal.style.display = "none";
      return;
    }

    // Reset localStorage if the customer is not logged in
    if (!isCustomerLoggedIn) {
      localStorage.setItem(localStorageKey, "false");
    }

    // Determine if the modal should display success or default messages
    if (pageLockType === 'Access Link' && isAccessLink) {
      updateModalContent(successTitle, successDescription, false);
      modalBox.classList.remove('opacity-0'); // Show the modal
    } else if (pageLockType === 'Customer' && isCustomerLoggedIn) {
      updateModalContent(successTitle, successDescription, false);
      modalBox.classList.remove('opacity-0'); // Show the modal
    } else if (pageLockType === 'Email subscription' && isCustomerLoggedIn && acceptsMarketing) {
      updateModalContent(successTitle, successDescription, false);
      modalBox.classList.remove('opacity-0'); // Show the modal

      // Hide the element with data-newsletter-embeded if success is showing for email subscription
      var newsletterEmbededElement = document.querySelector('[data-newsletter-embeded]');
      if (newsletterEmbededElement) {
        newsletterEmbededElement.style.display = 'none';
      }
    } else {
      updateModalContent(defaultTitle, defaultDescription, true);
      modalBox.classList.remove('opacity-0'); // Show the modal
    }

    // Close button logic
    modalCloseButton.addEventListener("click", function () {
      modal.style.display = "none";
      localStorage.setItem(localStorageKey, "true"); // Save the unlocked state for this collection
    });

    // Helper function to update modal content
    function updateModalContent(title, description, hideSuccessButtons) {
      modalContent.querySelector('h2').textContent = title;
      modalContent.querySelector('p').textContent = description;
      successButtonsWrapper.classList.toggle('hidden', hideSuccessButtons);
    }
  });
};
function setupVideoMuteToggle(videoId, buttonId, mutedIconHtml, unmutedIconHtml) {
  var video = document.getElementById(videoId);
  var toggleButton = document.getElementById(buttonId);
  if (video && toggleButton) {
    toggleButton.innerHTML = mutedIconHtml;
    toggleButton.addEventListener('click', function () {
      if (video.muted) {
        video.muted = false;
        toggleButton.innerHTML = unmutedIconHtml;
      } else {
        video.muted = true;
        toggleButton.innerHTML = mutedIconHtml;
      }
    });
  }
}
function initSwiperForBlock(blockIndex, swiperContainerElement) {
  var featuredCollectionWrapper = swiperContainerElement.closest('.featured-collection-wrapper');
  var backwardBtn = featuredCollectionWrapper ? featuredCollectionWrapper.querySelector('.js-scroll-backward') : null;
  var forwardBtn = featuredCollectionWrapper ? featuredCollectionWrapper.querySelector('.js-scroll-forward') : null;
  var progressBar = featuredCollectionWrapper ? featuredCollectionWrapper.querySelector('.progress-bar') : null;
  var swiper = new Swiper(swiperContainerElement, {
    loop: false,
    grabCursor: true,
    slidesPerView: 2,
    spaceBetween: 10,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    },
    observer: true,
    observeParents: true,
    on: {
      slideChange: function slideChange() {
        if (progressBar) {
          var progress = this.realIndex / (this.slides.length - this.params.slidesPerView) * 100;
          progressBar.style.width = Math.min(progress, 100) + '%';
        }
        if (backwardBtn) {
          backwardBtn.classList.toggle('opacity-30', this.isBeginning && !this.params.loop);
        }
        if (forwardBtn) {
          forwardBtn.classList.toggle('opacity-30', this.isEnd && !this.params.loop);
        }
      },
      init: function init() {
        if (progressBar) {
          progressBar.style.width = '0%';
        }
        if (backwardBtn) {
          backwardBtn.classList.toggle('opacity-30', this.isBeginning && !this.params.loop);
        }
        if (forwardBtn) {
          forwardBtn.classList.toggle('opacity-30', this.isEnd && !this.params.loop);
        }
      }
    }
  });
  if (backwardBtn) {
    backwardBtn.addEventListener('click', function (e) {
      e.preventDefault();
      swiper.slidePrev();
    });
  }
  if (forwardBtn) {
    forwardBtn.addEventListener('click', function (e) {
      e.preventDefault();
      swiper.slideNext();
    });
  }
}
function initCollectionMediaBlocks() {
  var _document$getElementB, _document$getElementB2;
  var mutedIconHtml = ((_document$getElementB = document.getElementById('volume-muted-icon-template')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.innerHTML) || '';
  var unmutedIconHtml = ((_document$getElementB2 = document.getElementById('volume-unmuted-icon-template')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.innerHTML) || '';
  document.querySelectorAll('.featured-collection-wrapper[data-block-index]').forEach(function (blockWrapper) {
    var blockIndex = blockWrapper.dataset.blockIndex;
    var swiperContainer = blockWrapper.querySelector(".swiper[data-swiper-id=\"collection-media-swiper-".concat(blockIndex, "\"]"));
    if (swiperContainer) {
      initSwiperForBlock(blockIndex, swiperContainer);
    }
    setupVideoMuteToggle("desktop-background-video-".concat(blockIndex), "desktop-mute-toggle-".concat(blockIndex), mutedIconHtml, unmutedIconHtml);
    setupVideoMuteToggle("mobile-background-video-".concat(blockIndex), "mobile-mute-toggle-".concat(blockIndex), mutedIconHtml, unmutedIconHtml);
  });
}
removeProductCards();
sortBy();
initCollectionLocks();
initCollectionMediaBlocks();
/******/ })()
;